﻿const permissionGet = () => {
    const key = 'permissionCache';
    const elementId = 'cache-data';

    //exit: no sessionStorage
    if (!window.sessionStorage) return null;

    //existing
    let base64Value = sessionStorage.getItem(key);
    const element = document.getElementById(elementId);

    //load from html, store
    if (!base64Value && element) {
        base64Value = element.textContent.trim();
        if (base64Value) {
            sessionStorage.setItem(key, base64Value);
        }
    }

    //remove (always)
    if (element) {
        element.remove();
    }

    //return
    try {
        return base64Value ? JSON.parse(decodeURIComponent(escape(atob(base64Value)))) : null;
    } catch (e) {
        //console.error(e);
        return null;
    }
};

//https://stackoverflow.com/a/65000691
const loadHandler = handler => {
    let waiting = 0

    const onload = el => {
        waiting++
        el.addEventListener('load', () => {
            waiting--
            if (waiting === 0) {
                handler()
            }
        })
    }

    return onload
};

const keyboard = async (enable, action) => {

    //keyboard enter
    let enter = async (e) => {
        if (e.key === 'Enter' && action != null) {
            await action();
        }
    };

    //listener
    if (enable === true) {
        document.addEventListener('keypress', enter, false);
    }
    else {
        document.removeEventListener('keypress', enter, false);
    }

};

class HelperFetch {

    #blobContentType = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.ms-powerpoint',
        'application/octet-stream',
        'application/x-zip-compressed',
        'text/csv',
        'application/pdf',
        'image/jpeg',
        'image/gif',
        'image/png',
        'message/rfc822',
    ];

    constructor() {
        this.validationSummaryVisible = false;
    }

    clearValidation = () => {

        //remove .validation-summary children
        [].forEach.call(document.querySelectorAll('.validation-summary'), function (node) {
            while (node.firstChild) {
                node.removeChild(node.firstChild);
            }
        });

        //remove .is-invalid
        [].forEach.call(document.querySelectorAll('.is-invalid'), function (node) {

            //remove placeholder
            if (node.placeholder)
                node.placeholder = '';

            //remove class
            node.classList.remove('is-invalid');

            //remove attribute
            node.removeAttribute('aria-required');
            node.removeAttribute('aria-invalid');
            node.removeAttribute('aria-describedby');

            //reset label
            let label = node.getAttribute('data-label');
            if (label) {
                node.setAttribute('aria-labelledby', label);
                node.removeAttribute('data-label');
            }
        });

        //remove .invalid-feedback
        [].forEach.call(document.querySelectorAll('.invalid-feedback'), function (node) {
            node.parentNode.removeChild(node);
        });

        //hide validation summary
        this.validationSummaryVisible = false;
        dispatchEvent(new CustomEvent('validationVisibility', {
            detail: {
                validationSummaryVisible: this.validationSummaryVisible
            }
        }));
    }

    fetchHandler = (response) => {

        //console.log('fetchHandler', response);

        function redirect(url) {
            window.location.replace(url);
        }

        //redirect
        if ((response.redirected === true || response.status === 302) && response.url) {
            redirect(response.url);
            return null;
        }

        //ie doesn't handle 302 correctly, look for header instead
        var location = response.headers.get('location');
        if (location) {
            redirect(location);
            return null;
        }

        var contentType = response.headers.get('content-type');

        if (contentType && contentType.indexOf('application/json') >= 0) {

            return response.json()
                .then(function (json) {
                    if (response.ok) {
                        return json;
                    } else {
                        return Promise.reject(Object.assign({}, json, {
                            status: response.status,
                            statusText: response.statusText
                        }));
                    }
                });

        } else if (contentType && (contentType.indexOf('text/html') >= 0 || contentType.indexOf('text/plain') >= 0)) {

            return response.text()
                .then(function (text) {
                    if (response.ok) {
                        return text;
                    } else {
                        return Promise.reject({
                            status: response.status,
                            statusText: response.statusText,
                            err: text
                        });
                    }
                });

        } else if (contentType && this.#blobContentType.includes(contentType)) {
            return response.blob();
        }
        else if (contentType === null) {
            if (response.status) {
                return { status: response.status, statusText: response.statusText };
            }
        } else {
            //console.log(response);
            throw new Error('Content-Type ' + contentType + ' not handled by fetch plugin');
        }
    }

    errorHandler = (error, containerId) => {

        //console.log('errorHandler', error, containerId);

        //retro fit
        if (error.Status && error.Status === 'Invalid') {
            error.status = 400;
        }

        if (error.status === 400) { //validation

            //clear validation
            this.clearValidation();

            //add in validation
            if (error) {

                //cleanup on containerid
                if (containerId === null || containerId === undefined)
                    containerId = '';
                else
                    containerId = containerId + ' '; //space for querySelector

                //validation summry: get
                let validationSummary = document.querySelector(containerId + '.validation-summary');

                //place error text and/or class
                let count = 1;
                let fieldElementInvalid = false;
                let validationSummaryInvalid = false;
                for (var field in error) {

                    if (field === 'status') continue;
                    if (field === 'statusText') continue;

                    let errorText = error[field];
                    let fieldElement = document.querySelector(containerId + "[name='" + field + "']");

                    if (!fieldElement && field[0]) { //camel case
                        let fieldCamelCase = field[0].toLowerCase() + field.substring(1, field.length);
                        fieldElement = document.querySelector(containerId + "[name='" + fieldCamelCase + "']");
                    }

                    if (fieldElement) { //validation single

                        //parent is .input-group
                        let parent = fieldElement.parentNode;
                        let parentInputGroup = parent.className.indexOf('input-group') >= 0;
                        let errId = `err_${count}`;

                        //css
                        fieldElement.classList.add('is-invalid');

                        //aria
                        fieldElement.setAttribute('aria-required', 'true');
                        fieldElement.setAttribute('aria-invalid', 'true');
                        fieldElement.setAttribute('aria-describedby', errId);

                        if (fieldElement.tagName === 'INPUT' || fieldElement.tagName === 'TEXTAREA' || fieldElement.tagName === 'SELECT') {
                            if (parentInputGroup === true) {
                                parent.classList.add('is-invalid');
                                parent.insertAdjacentHTML('afterend', `<div id='${errId}' class='invalid-feedback'>` + errorText + "</div>");
                            } else {
                                fieldElement.insertAdjacentHTML('afterend', `<div id='${errId}' class='invalid-feedback'>` + errorText + "</div>");
                            }
                        }
                        else if (fieldElement.tagName === 'DIV') {

                            //message
                            fieldElement.insertAdjacentHTML('afterend', `<div id='${errId}' class='invalid-feedback'>` + errorText + "</div>");

                            //original label
                            var ariaLabelBy = fieldElement.getAttribute('aria-labelledby');
                            if (ariaLabelBy) {
                                fieldElement.setAttribute('data-label', ariaLabelBy);
                            }

                            //change label
                            fieldElement.setAttribute('aria-labelledby', errId);
                        }

                        //validation summary: show
                        fieldElementInvalid = true;
                    }
                    else if (validationSummary) { //validation summary

                        let li;

                        if (Object.prototype.toString.call(errorText) === '[object Array]') { //is array

                            for (var i = 0; i < errorText.length; i++) {

                                //li: new
                                li = document.createElement('li');
                                li.innerHTML = errorText[i];

                                //li: append
                                validationSummary.appendChild(li);
                            }

                        } else { //not array

                            //li: new
                            li = document.createElement('li');
                            li.innerHTML = errorText;

                            //li: append
                            validationSummary.appendChild(li);
                        }

                        //validation summary: show
                        validationSummaryInvalid = true;
                    }

                    //increment
                    count++;
                }

                //validation summary: all
                if (validationSummary && fieldElementInvalid == true) {
                    validationSummary.insertAdjacentHTML('afterbegin', '<li>Please review for required or invalid information.</li>');
                }

                //validation summary: trigger visible
                if (fieldElementInvalid == true || validationSummaryInvalid == true) {
                    dispatchEvent(new CustomEvent('validationVisibility', {
                        detail: {
                            validationSummaryVisible: true
                        }
                    }));
                }
            }
        } else if (error.status === 302) {
            if (error.value) {
                redirect(error.value.url);
            }
        } else if (error.status === 401 || error.status === 403) {
            //ignore
        }
        else if (error.name === 'AbortError') {
            //ignore
        }
        else {
            console.error(error);
        }
    }

}

class HelperFunction {

    debounceViaAnimation = (fn) => {

        // setup a timer
        var timeout;

        // return a function to run debounced
        return function () {

            // setup the arguments
            var context = this;
            var args = arguments;

            // if there's a timer, cancel it
            if (timeout) {
                window.cancelAnimationFrame(timeout);
            }

            // setup the new requestAnimationFrame()
            timeout = window.requestAnimationFrame(function () {
                fn.apply(context, args);
            });
        }
    };

    debounce = (func, duration) => {

        let timeout;

        return function (...args) {

            const effect = () => {
                timeout = null;
                return func.apply(this, args);
            }

            clearTimeout(timeout);
            timeout = setTimeout(effect, duration);
        }
    };

    arrayChange = (value, arr) => {

        if (Array.isArray(arr) == false)
            arr = [];

        let index = arr.indexOf(value);

        if (index == -1) {
            arr.push(value);
        } else if (index > -1) {
            arr.splice(index, 1);
        }

        return arr;
    };

    mask = (element, prop, type, onChange) => {

        //console.log(element, name, type);

        if (element == null)
            return;

        //ensure
        if (window.maskDefined === undefined) {
            window.maskDefined = {};
        }

        //destroy
        if (window.maskDefined[prop] !== undefined) {
            window.maskDefined[prop].destroy();
        }

        //console.log('mask', element, name, type);

        if (type === 'numeric-decimal1') {

            window.maskDefined[prop] = IMask(element,
                {
                    mask: Number,
                    // other options are optional with defaults below
                    scale: 1,  // digits after point, 0 for integers
                    signed: true,  // disallow negative
                    thousandsSeparator: '',  // any single char
                    padFractionalZeros: false,  // if true, then pads zeros at end to the length of scale
                    normalizeZeros: true,  // appends or removes zeros at ends
                    radix: '.',  // fractional delimiter
                    mapToRadix: ['.']  // symbols to process as radix
                });

        }

        if (type === 'numeric-decimal2') {

            window.maskDefined[prop] = IMask(element,
                {
                    mask: Number,
                    // other options are optional with defaults below
                    scale: 2,  // digits after point, 0 for integers
                    signed: true,  // disallow negative
                    thousandsSeparator: '',  // any single char
                    padFractionalZeros: false,  // if true, then pads zeros at end to the length of scale
                    normalizeZeros: true,  // appends or removes zeros at ends
                    radix: '.',  // fractional delimiter
                    mapToRadix: ['.']  // symbols to process as radix
                });

        }

        if (type === 'numeric-decimal4') {

            window.maskDefined[prop] = IMask(element,
                {
                    mask: Number,
                    // other options are optional with defaults below
                    scale: 4,  // digits after point, 0 for integers
                    signed: true,  // disallow negative
                    thousandsSeparator: '',  // any single char
                    padFractionalZeros: false,  // if true, then pads zeros at end to the length of scale
                    normalizeZeros: true,  // appends or removes zeros at ends
                    radix: '.',  // fractional delimiter
                    mapToRadix: ['.']  // symbols to process as radix
                });

        }

        if (type === 'money') {

            window.maskDefined[prop] = IMask(element,
                {
                    mask: Number,
                    // other options are optional with defaults below
                    scale: 2,  // digits after point, 0 for integers
                    signed: true,  // disallow negative
                    thousandsSeparator: ',',  // any single char
                    padFractionalZeros: true,  // if true, then pads zeros at end to the length of scale
                    normalizeZeros: true,  // appends or removes zeros at ends
                    radix: '.',  // fractional delimiter
                    mapToRadix: ['.']  // symbols to process as radix
                });

        }

        if (type === 'numeric-int') {

            window.maskDefined[prop] = IMask(element,
                {
                    mask: Number,
                    // other options are optional with defaults below
                    scale: 0,  // digits after point, 0 for integers
                    signed: true,  // disallow negative
                    thousandsSeparator: '',  // any single char
                    padFractionalZeros: false,  // if true, then pads zeros at end to the length of scale
                    normalizeZeros: true,  // appends or removes zeros at ends
                    radix: '.',  // fractional delimiter
                    mapToRadix: ['.']  // symbols to process as radix
                });

        }

        if (type === 'digit-int') {

            window.maskDefined[prop] = IMask(element,
                {
                    mask: /^\d+$/
                });

        }

        if (type === 'phone-simple') {

            window.maskDefined[prop] = IMask(element,
                {
                    mask: '(000) 000-0000'
                });

        }

        if (type === 'phone') {

            window.maskDefined[prop] = IMask(element,
                {
                    mask: '(000) 000-0000 {x}[0000]'
                });

        }

        if (type === 'ssn') {

            window.maskDefined[prop] = IMask(element,
                {
                    mask: '000-00-0000'
                });

        }

        if (type === 'zip-simple') {

            window.maskDefined[prop] = IMask(element,
                {
                    mask: '00000'
                });

        }

        if (type === 'zip-full') {

            window.maskDefined[prop] = IMask(element,
                {
                    mask: '00000-0000'
                });

        }

        if (type === 'year4') {

            window.maskDefined[name] = IMask(element,
                {
                    mask: '0000'
                });

        }

        //value
        if (element.value) {
            window.maskDefined[prop].value = element.value;
        }

        //event
        if (onChange && window.maskDefined[prop]) {
            const e = () => onChange(window.maskDefined[prop].value);
            window.maskDefined[prop].on('accept', e);
            window.maskDefined[prop].on('remove', e);
            window.maskDefined[prop].on('clear', e);
        }

    };

    formatCurrency = (value) => {

        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);

    };

    formatDate = (value) => {

        if (value == null || value.length == 0)
            return null;

        let length = value.length;
        let isDate = (value instanceof Date);

        if (isDate == false)
            value = new Date(value);

        //console.log(value, isDate, length);

        if (isDate == false && length == 10) {
            //result: timezone not specified use GMT
            return (new Intl.DateTimeFormat('en-US', { timeZone: 'GMT' })).format(value);
        }
        else {
            //result: other, use default timezone
            return (new Intl.DateTimeFormat('en-US')).format(value);
        }

    };

    formatBooleanYesNo = (value) => {

        let result = this.parseBoolean(value);

        if (result === true)
            return 'Yes';
        else if (result === false)
            return 'No';

        return result;
    }

    formatPercentage = (value) => {

        return (value).toFixed(2) + '%';
    }

    formatFileSize = (value) => {

        const threshold = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (value === 0 || value === null) return '0 Bytes';

        let num = Math.abs(value);
        let index = 0;

        while (num >= 1024) {
            num /= 1024;
            index++;
        }

        return `${num.toFixed(2)} ${threshold[index]}`;
    }

    parseBoolean = (value) => {

        if (value === true || value === false) {
            return value;
        }

        if (value == null || value == undefined || value.length == 0) {
            return null;
        }

        switch (value.toLowerCase().trim()) {
            case "true": case "yes": case "1": return true;
            case "false": case "no": case "0": case null: return false;
            default: return Boolean(value);
        }

    }

    parseInt = (value) => {

        if (!(value === null || value === undefined || value === '')) {
            return parseInt((value.toString() ?? "").replaceAll(',', ''))
        }

        return null;
    }

    parseMoney = (value) => {

        if (!(value === null || value === undefined || value === '')) {
            return parseFloat((value.toString() ?? "").replaceAll(',', '')).toFixed(2);
        }

        return null;
    }
}

//https://javascript.info/cookie
class HelperCookie {
    get = (name) => {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    set = (name, value, attributes) => {
        attributes = {
            path: '/',
            // add other defaults here if necessary
            ...attributes
        };

        if (attributes.expires instanceof Date) {
            attributes.expires = attributes.expires.toUTCString();
        }

        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

        for (let attributeKey in attributes) {
            updatedCookie += "; " + attributeKey;
            let attributeValue = attributes[attributeKey];
            if (attributeValue !== true) {
                updatedCookie += "=" + attributeValue;
            }
        }

        document.cookie = updatedCookie;
    }

    remove = (name) => {
        set(name, "", {
            'max-age': -1
        })
    }
}

let helperFetch = new HelperFetch();
let helperFunction = new HelperFunction();
let helperCookie = new HelperCookie();
export { permissionGet, loadHandler, keyboard, helperFetch, helperFunction, helperCookie }